
import { Button } from "../../../common/Atoms/Button";
import { CardContent } from "../../../common/Atoms/CardContent";
import { Modal } from "../../../common/Atoms/Modal";
import { Notification } from "../../../common/Atoms/Notification";
import { useLeaveOrganisationMutation } from "../../services/api/organisationApi/organisation";
import { LoadingOverlay } from "../Molecules/LoadingOverlay";

interface LeaveConfirmationModalProps {
  open: boolean;
  setOpen: () => void;
  orgName: string;
  orgId: string;
  redirectToDashboard?: boolean;
}

export function LeaveConfirmationModal({
  open,
  setOpen,
  orgName,
  orgId,
  redirectToDashboard,
}: LeaveConfirmationModalProps) {
  const [leaveOrg, { isLoading: leaveOrgLoading }] = useLeaveOrganisationMutation();

  async function onLeave() {
    await leaveOrg({ organisationId: orgId });
    setOpen();

    if (redirectToDashboard) {
      // Redirect to dashboard
      window.location.href = `/`;
    }
  }

  return (
    <Modal
      title={ `Are you sure you want to leave ${orgName}?` }
      open={ open }
      setOpen={ setOpen }
      width={ `xl` }
    >
      <CardContent>
        <LoadingOverlay
          loading={ leaveOrgLoading }
        >
          <div
            className={ `flex flex-col justify-between` }
          >
            <Notification
              type={ `warning` }
              className={ `mt-6` }
            >
              { `If you leave, you will need to reconnect or be re-invited by an existing member to regain access.` }
            </Notification>
            <div
              className={ `flex justify-center space-x-2 mt-6` }
            >
              <Button
                color={ `red` }
                onClick={ onLeave }
                size={ `lg` }
              >
                { `Leave Organisation` }
              </Button>

              <Button
                color={ `gray` }
                onClick={ setOpen }
                size={ `lg` }
              >
                { `Cancel` }
              </Button>
            </div>
          </div>
        </LoadingOverlay>
      </CardContent>
    </Modal>
  );
}
